import { format as formatDate } from 'date-fns';
import useFindPromotionsQuery from '@/api/queries/useFindPromotionsQuery';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import Pagination from '@/components/Pagination';
import { SearchProps } from '@/components/search/useSearch';
import StatusActiveIndicator from '@/components/StatusActiveIndicator';
import { isStatusActive } from '@/models/Status';
import { PromotionEditPath } from '@/modules/product/paths';
import { Link } from 'react-router-dom';

const PromotionTable = ({ searchQuery, page = 1, onChangePage = () => {} }: SearchProps) => {
  const { promotions, isLoading, itemsPerPage } = useFindPromotionsQuery(page, searchQuery);

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className={isLoading ? 'loading' : ''}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Created At</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {promotions.items.map((promotion) => {
              if (!promotion.id) return null;

              return (
                <tr key={promotion.id}>
                  <td>
                    <Link
                      to={PromotionEditPath.withId(promotion.id)}
                      className="text-blue-500 hover:underline"
                    >
                      {promotion.name}
                    </Link>
                  </td>
                  <td>{promotion.createdAt && formatDate(promotion.createdAt, 'd MMM yyyy')}</td>
                  <td>
                    <StatusActiveIndicator isActive={isStatusActive(promotion)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {isLoading && (
          <div role="status" className="loader">
            <SpinnerIcon />
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </div>
      <div className="table-bottom">
        <Pagination
          currentPage={page}
          itemsPerPage={itemsPerPage}
          totalCount={promotions.totalCount || 0}
          estimatedTotalCount={promotions.estimatedTotalCount || 0}
          onClick={onChangePage}
        />
      </div>
    </div>
  );
};

export default PromotionTable;
